import { useNavigate } from 'react-router-dom';

import { memberPath, membershipPath, paths, privacyRequestsPath, registrationsPath } from '@/app/paths';
import { useOverlays } from '@/components/Overlays';
import type { AppNotification } from '@escala/domain/notifications';
import { useStore } from '@/store/AppStore';

/**
 * Abrir uma notificação: marca como lida e leva ao evento, ao membro, às solicitações de
 * cadastro, aos pedidos de privacidade, à "Minha agenda" (os pedidos de troca), aos
 * visitantes ou aos aniversariantes da Membresia.
 */
export function useOpenNotification(): (notification: AppNotification) => void {
  const { actions } = useStore();
  const { openEvent, openPrivacy } = useOverlays();
  const navigate = useNavigate();

  return (notification) => {
    actions.markRead([notification.id]);

    if (notification.target?.type === 'event') openEvent(notification.target.id);
    if (notification.target?.type === 'member')
      navigate(memberPath(notification.target.id, 'disponibilidade'));
    if (notification.target?.type === 'registrations') navigate(registrationsPath);
    if (notification.target?.type === 'agenda') navigate(paths.agenda);
    if (notification.target?.type === 'visitors') {
      navigate(membershipPath('visitantes', { overdue: notification.target.overdue }));
    }
    if (notification.target?.type === 'birthdays') navigate(membershipPath('aniversariantes'));
    // Pedido de privacidade: o Administrador responde em Configurações; quem pediu vê a resposta.
    if (notification.target?.type === 'privacy') {
      if (notification.target.scope === 'answer') navigate(privacyRequestsPath);
      else openPrivacy();
    }
  };
}
